module.exports = __webpack_public_path__ + "img/check.82df20f5.png";